'use strict';

const loadMoreButtons = document.querySelectorAll('.news-overview .btn-load-more');
const listingWrap = document.querySelector('.news-overview .listing-wrap');

loadMoreButtons.forEach((button) => {

  button.addEventListener('click', function () {

    listingWrap.classList.add('visible-all');
    button.parentNode.classList.add('d-none');

  });

});

function initCustomSelect() {

  function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    let x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt === y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  let x, i, j, l, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /* For each option in the original select element,
      create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML === this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            s.click();
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
      /* When the select box is clicked, close any other select boxes,
      and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  /* If the user clicks anywhere outside the select box,
  then close all select boxes: */
  document.addEventListener("click", closeAllSelect);

}

function getPosts(year) {

  const listingWrap = document.querySelector('.news-overview .listing-wrap');
  const btnMoreDesktop = document.querySelector('.news-overview .btn-more-desktop');
  const btnMoreMobile = document.querySelector('.news-overview .btn-more-mobile');

  const data = new FormData();

  data.append( 'action', 'post_year_filter' );
  data.append( 'year', year );

  fetch(ajax_object.ajax_url , {
    method: "POST",
    credentials: 'same-origin',
    body: data,
  })
    .then((response) => response.json())
    .then((data) => {
      if (!data) return false;

      listingWrap.classList.remove('visible-all');
      listingWrap.innerHTML = data.data.postsHtml;

      let totals = data.data.total;

      if(totals > 4) {
        btnMoreMobile.classList.remove('d-none');
      } else {
        btnMoreMobile.classList.add('d-none');
      }

      if(totals > 8) {
        btnMoreDesktop.classList.remove('d-none');
      } else {
        btnMoreDesktop.classList.add('d-none');
      }

    })
    .catch((error) => {
      console.log('[Post filter year]');
      console.error(error);
    });

}

function initCustomSelectAction() {

  const select = document.querySelector('.news-overview select');

  select.addEventListener('click', function (e) {

    let year = select.options[select.selectedIndex].value;

    getPosts(year);

  });

}

initCustomSelectAction();
initCustomSelect();
